



















import ApiConfiguration from '@/classes/ApiConfiguration';
import { DocumentPrintResponseModel } from '@/services/GeneratedApi';
import { Base64Utils } from '@/utils';
import Vue from 'vue';
import LoadingSpinner from './LoadingSpinner.vue';
import MStoreSpinnerButton from './MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'MStorePrintDocument',
  props: {
    cabinetId: {
      type: String
    },
    documentId: {
      type: Number
    },
    size: {
      type: String,
      required: false
    },
    isDropdownButton: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async print(this: any) {
      this.isLoading = true;
      let url = '';

      try {
        const pdfDocument = (await ApiConfiguration.api().documentPrint.documentPrintPdfDetail(this.cabinetId, this.documentId)) as DocumentPrintResponseModel;
        url = Base64Utils.previewBase64(pdfDocument.base64Data!, null);
      } catch (error) {
        this.$log('Error fetching document for print:', error);
        return;
      } finally {
        this.isLoading = false;
      }

      this.loadIFrameInPrintDialog(url);
    },

    loadIFrameInPrintDialog(this: any, url: string) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);

      const vm = this;
      let cleanupCalled = false;
      const cleanup = () => {
        if (!cleanupCalled && iframe.parentNode) {
          cleanupCalled = true;
          iframe.parentNode.removeChild(iframe);
        }
      };

      iframe.onload = () => {
        let afterPrintHandler: (() => void) | null = null;
        const contentWindow = iframe.contentWindow;
        let afterPrintSupported = false;
        if (contentWindow) {
          try {
            afterPrintHandler = () => {
              if (contentWindow) {
                contentWindow.removeEventListener('afterprint', afterPrintHandler!);
              }
              cleanup();
            };
            contentWindow.addEventListener('afterprint', afterPrintHandler);
            afterPrintSupported = true;
          } catch (e) {
            afterPrintSupported = false;
          }
        }
        try {
          contentWindow?.print();
        } catch (e) {
          vm.$log('Failed to print document:', e);
          cleanup();
          return;
        }
        if (!afterPrintSupported) {
          setTimeout(cleanup, 2000);
        }
      };

      iframe.onerror = (event, source, lineno, colno, error) => {
        vm.$log('Failed to load iframe for printing:', event);
        setTimeout(cleanup, 1000);
      };
    }
  },
  components: { MStoreSpinnerButton, LoadingSpinner }
});
